module.exports = __webpack_public_path__ + "img/lead-flight.1295d194.svg";